<template>
  <header class="header">
    <router-link :to="`/${currentLang}`" class="header__logo">
      <h1>
        <img src="/img/app/acres.svg" alt="Logo Acres">
      </h1>
    </router-link>

    <HeaderNavigator data-mobileMenu="hidden"/>

    <div
      class="burger u-hidden--from-ipadP"
      @click="toggleMenu()"
    >
      <div class="burger__container">
        <span></span>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import HeaderNavigator from '@/components/HeaderNavigator.vue';

export default {
  name: 'HeaderComponent',

  components: {
    HeaderNavigator,
  },

  computed: {
    ...mapState(['currentLang']),
  },

  methods: {
    toggleMenu() {
      const menu = this.$el.querySelector('[data-mobileMenu]');
      const burger = this.$el.querySelector('.burger');
      const state = menu.getAttribute('data-mobileMenu');
      if (state === 'hidden') {
        burger.classList.add('close');
        menu.setAttribute('data-mobileMenu', 'visible');
      } else if (state === 'visible') {
        burger.classList.remove('close');
        menu.setAttribute('data-mobileMenu', 'hidden');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 20px 40px;

  z-index: 30;

  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-flow: row wrap;

  @include mq(ipadP) {
    &[data-theme][data-position] {
      transition: transform 0.3s ease-in-out,
        background-color 0.3s ease-in-out;
    }

    &[data-theme="white"] {
      background-color: $color-beige;

      &::v-deep a {
        color: $color-black;
      }
    }

    &[data-position="hidden"] {
      transform: translateY(-100%);
    }
  }

  img,
  a,
  h1 {
    position: relative;
    width: 100px;
    height: 31px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__logo,
  .burger {
    z-index: 10;
  }
}

.burger {
  width: 44px;
  height: 44px;
  padding: 12px;

  background: none;
  border: 0;
  border-radius: 40px;

  visibility: visible;
  cursor: pointer;

  background: black;

  &:focus {
    outline: none;
  }

  .burger__container {
    position: relative;
    width: 20px;
    height: 20px;

    transform: scale(0.8);
  }

  &.close .burger__container {
    span {
      transform: rotate(-45deg) scale(1.38, 1);
    }

    &::after {
      transform: rotate(45deg);
    }

    &::before {
      transform: rotate(45deg);
    }
  }

  span {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 1px;
    background: lighten($color-white, 60%);
    transition: all 0.35s ease-out;
  }

  & .burger__container::after,
  & .burger__container::before {
    content: "";
    position: absolute;
    height: 1px;
    width: 50%;
    background: lighten($color-white, 40%);
    transition: all 0.3s ease-out;
  }

  & .burger__container::after {
    right: 0;
    bottom: 0;
    transform-origin: 100% 50%;
  }

  & .burger__container::before {
    left: 0;
    top: 0;
    transform-origin: 0 50%;
  }
}
</style>
